/**
 * Bridge between server ISO-UTC strings and the browser's native
 * `<input type="datetime-local">`, which speaks the editor's local timezone in
 * a `YYYY-MM-DDTHH:MM` string (no offset). Callers should surface a separate
 * "preview in display timezone" line so editors in a non-event timezone can
 * still verify the real moment before committing.
 */

const pad = (n: number): string => String(n).padStart(2, '0');

export function isoToLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function localInputToIso(local: string): string | null {
  if (!local) return null;
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
